export type CommentType =
  | BillableCommentType
  | NonBillableCommentType
  | AbuseCommentType
  | BugReportCommentType;

export enum BillableCommentType {
  CNPFSL = 'CNPFSL',
  CNPVRI = 'CNPVRI',
  CNPHang = 'CNPHang',
  CNPHrss = 'CNPHrss',
  CNPOther = 'CNPOther',
  NSLCust = 'NSLCust',
  NSLFor = 'NSLFor',
  NSLRpeat = 'NSLRpeat',
  Other = 'Other',
  TechAud = 'TechAud',
  TechBlck = 'TechBlck',
  TechFroz = 'TechFroz',
  TechOthr = 'TechOthr',
  TechStat = 'TechStat',
  TechDrop = 'TechDrop',
  TestCust = 'TestCust',
  TestExpT = 'TestExpT',
  TestInt = 'TestInt',
}

export enum NonBillableCommentType {
  VRI = 'VRI',
  _911VRI = '911VRI',
  TESTTRN = 'TESTTRN',
  IllegVCO = 'IllegVCO',
  DualRly = 'DUALRLY',
  OTHERNBL = 'OTHERNBL',
}

export enum AbuseCommentType {
  ABUSE2 = 'ABUSE2',
  ABUSTERP = 'ABUSTERP',
}

export enum BugReportCommentType {
  BRVIDPIX = 'BRVIDPIX',
  BRVIDFRZ = 'BRVIDFRZ',
  BRVIDBKI = 'BRVIDBKI',
  BRVIDBKC = 'BRVIDBKC',
  BRAUDCON = 'BRAUDCON',
  BRAUDDST = 'BRAUDDST',
  BRAUDECO = 'BRAUDECO',
  BRTXTNVC = 'BRTXTNVC',
  BRTXTNVI = 'BRTXTNVI',
  BREMAGCY = 'BREMAGCY',
  BREMNLOC = 'BREMNLOC',
  BRDPNSEE = 'BRDPNSEE',
  BRDPNSND = 'BRDPNSND',
  BRTMCREQ = 'BRTMCREQ',
  BRTMFAIL = 'BRTMFAIL',
  BRTMWLOC = 'BRTMWLOC',
  BRHOIRTQ = 'BRHOIRTQ',
  BRHOIWRM = 'BRHOIWRM',
  BROTHERB = 'BROTHERB',
}
